/**
 * KW Customs conversion tracking.
 * Pushes events to GTM dataLayer for measuring the mailer campaign and
 * contact-form conversions.
 *
 * Usage: mark an element with data-track-event="event_name" and (optional)
 *   data-track-label="..." / data-track-value="..." attributes. On click,
 *   a dataLayer.push will fire with the event and metadata.
 *
 * Contact forms with class "contact-form" or data-track-submit attribute
 * fire a "contact_submit" event on successful submission.
 */
(function () {
  if (typeof window === 'undefined') return;
  window.dataLayer = window.dataLayer || [];

  function trackClick(el) {
    var event = el.getAttribute('data-track-event');
    if (!event) return;
    var payload = {
      event: event,
      category: el.getAttribute('data-track-category') || 'engagement',
      label: el.getAttribute('data-track-label') || el.textContent.trim().slice(0, 80),
      page_path: window.location.pathname,
    };
    var value = el.getAttribute('data-track-value');
    if (value != null && value !== '') payload.value = isNaN(+value) ? value : +value;
    window.dataLayer.push(payload);
  }

  document.addEventListener('click', function (e) {
    var target = e.target;
    while (target && target !== document.body) {
      if (target.hasAttribute && target.hasAttribute('data-track-event')) {
        trackClick(target);
        return;
      }
      target = target.parentNode;
    }
  }, { capture: true });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    var isContact =
      form.classList.contains('contact-form') ||
      form.hasAttribute('data-track-submit') ||
      (form.action && form.action.indexOf('contact') !== -1);
    if (!isContact) return;
    window.dataLayer.push({
      event: form.getAttribute('data-track-submit') || 'contact_submit',
      category: 'lead',
      label: form.getAttribute('data-track-label') || 'Contact form',
      page_path: window.location.pathname,
    });
  }, { capture: true });
})();
